import { useEffect, useState } from "react";
import { deleteModel, getModelById } from "../../services/DataModelService";
import ViewMetricByModel from "../../components/configuration/ViewMetricByModel";
import { useDisclosure } from "@chakra-ui/react";
import { Header, ModelInfo } from "build-ts/metadata";
import { listMetrics } from "../../services/MetricService";
import { useNavigate } from "react-router-dom";

interface ViewMetricByModelContainerProps {
  modelList: Header[];
  setModelList: React.Dispatch<React.SetStateAction<Header[]>>;
}

const ViewMetricByModelContainer: React.FC<ViewMetricByModelContainerProps> = ({ modelList, setModelList }) => {
  const navigate = useNavigate();
  const [modelInfo, setModelInfo] = useState<ModelInfo | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [metricFlag, setMetricFlag] = useState<boolean>(false);
  const [modelFlag, setModelFlag] = useState<boolean>(false);
  const [deleteModelId, setDeleteModelId] = useState<string | null>(null);
  const [dependentMetricHeaders, setDependentMetricHeaders] = useState<Header[]>([]);
  const deleteModal = useDisclosure();
  const [modelsWithMissingKG, setModelsWithMissingKG] = useState<Set<string>>(new Set());
  const [metricList, setMetricList] = useState<Header[]>([]);


  // fetch all metrics
  useEffect(() => {
    const fetchAllMetrics = async () => {
      const data = await listMetrics("");
      setMetricList(data);
    };
    fetchAllMetrics();
  }, []);

  const handleModelInfo = async (id: string) => {
    const data = await getModelById(id);
    if (data) {
      setModelInfo(data);
    }
    onOpen();
  };

  const handleCreateMetric = async (id: string) => {
    await handleModelInfo(id);
    setMetricFlag(true);
  };

  const handleUpdateModel = async (id: string) => {
    navigate(`/mkg/models/${id}`);
  };

  const handleDeleteModel = async (id: string) => {
    const response = await deleteModel(id);
    if (response.length > 0) {
      deleteModal.onOpen();
      setDependentMetricHeaders(response);
    } else {
      setModelList((prevList) => prevList.filter((model) => model.id !== id));
      setModelsWithMissingKG(prev => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
    }
  };

  const closeMetric = () => {
    setMetricFlag(false);
    onClose();
  };

  // Function to handle the confirmation of deletion
  const confirmDelete = () => {
    if (deleteModelId) {
      handleDeleteModel(deleteModelId);
      setDeleteModelId(null); // Reset the deleteId after deletion
    }
    deleteModal.onClose();
  };

  // Function to handle the back button
  const onBack = () => {
    setModelFlag(false);
  };

  // Render the ViewMetric component
  return (
    <ViewMetricByModel
      listModel={modelList}
      metricList={metricList}
      handleCreateMetric={handleCreateMetric}
      modelInfo={modelInfo}
      isOpen={isOpen}
      metricFlag={metricFlag}
      closeMetric={closeMetric}
      handleUpdateModel={handleUpdateModel}
      modelFlag={modelFlag}
      deleteModal={deleteModal}
      confirmDelete={confirmDelete}
      setDeleteModelId={setDeleteModelId}
      dependentMetricHeaders={dependentMetricHeaders}
      setDependentMetricHeaders={setDependentMetricHeaders}
      modelsWithMissingKG={modelsWithMissingKG}
      onBack={onBack}
    />
  );
};

export default ViewMetricByModelContainer;
